module.exports = __webpack_public_path__ + "img/payment_card.f1eeb5d2.png";